import { FC, memo } from 'react';

import { Card } from 'antd';

// Components
import { EventButton } from './button';
import EventCountDown from './countdown';

// Utils
import { getEventoImagePath } from '../../../../../../utils/getImagePath';

// Interfaces
import type { PublicEventRead } from '../../../../../../interfaces/evento';

interface SubscribeCardProps {
  isAcredited?: boolean;
  isInscripted?: boolean;
  evento: PublicEventRead;
}

export const SubscribeCard: FC<SubscribeCardProps> = memo((props) => {
  const { evento, isInscripted = false, isAcredited = false } = props;

  return (
    <Card
      cover={
        <div className="event-card-image">
          <img
            alt="imagen-del-evento"
            src={getEventoImagePath(evento, true)}
            style={{ height: 240, width: '100%', objectFit: 'cover' }}
          />
        </div>
      }
    >
      <div>
        <EventButton evento={evento} isInscripted={isInscripted} isAcredited={isAcredited} />
      </div>

      <div>
        <EventCountDown evento={evento} isInscripted={isInscripted} isAcredited={isAcredited} />
      </div>
    </Card>
  );
});

SubscribeCard.displayName = 'SubscribeCard';

export default SubscribeCard;
